module.exports = __webpack_public_path__ + "img/staff.2518a82f.svg";